/* PureEthical - pe-colour-swap.js   (v7)

   A) as bolas de cor passam a BOLINHAS pintadas por nos;
   B) a galeria mostra TODAS as fotos da cor escolhida - e so' essas;
   C) ficha com cor e sem tamanhos: escolhe a variante ao abrir.

   ===============================================================
   B) PORQUE E' QUE APARECIA UMA SO' FOTO - a historia toda

   Primeira tentativa: comparar o nome da cor com o texto alternativo
   da foto. Falhou porque a loja e' multilingue - a bola diz "Noir" e
   o alt diz "Preto" (ou ao contrario, conforme seja a traducao da
   Shopify ou o Google Translate, que tambem reescreve o alt). Sem
   correspondencia, caia na reserva.

   Segunda tentativa: identificar as fotos pelo endereco, que ninguem
   traduz. O calculo estava certo - e continuava a aparecer uma foto.

   A razao verdadeira e' esta: ao clicar numa cor, QUATRO pedacos de
   codigo do tema esvaziam o #galSlider e reconstroem-no, cada um por
   sua conta, todos a partir do data-images da bola - que tem UMA
   unica foto por cor (o product-page.liquid monta-o do featured_image
   de cada variante). Sao eles:
       pe-gallery.js  initColourSwatches -> swapSliderImages
       theme.js       ~211  -> swapSliderImages
       theme.js       ~324  -> swapSliderImages   (duplicado do de cima)
       theme.js       ~505  -> swapGallery        (funcao propria)
   e o swapSliderImages que acaba por correr e' o do pe-conversion.js,
   que faz slider.innerHTML = '' e reconstroi.

   O meu codigo corria em ultimo (ouvinte no document, por bolha) e
   limitava-se a reescrever o src dos nos existentes. So' que a essa
   altura ja' so' existia UM no. A lista que eu calculava estava
   certa; o que tinha sido destruido era o numero de enquadramentos.

   Por isso agora NAO se reaproveitam os nos: reconstroi-se a galeria
   inteira, com a mesma estrutura que o tema usa. Como este ficheiro
   corre depois de todos, e' o ultimo a escrever e fica a mandar.
   Reaplica-se ainda passado um instante, para o caso de algo assincrono
   voltar a mexer.

   O retrato das fotos originais (SNAP) e' tirado UMA vez, no arranque,
   antes de qualquer reconstrucao - e' dele que sai tudo o resto.

   Como este ficheiro passa a ser dono da galeria, traz tambem o que
   se perdia ao substituir os nos: clicar numa foto, os pontinhos e as
   setas.

   ===============================================================
   A) A COR DAS BOLINHAS
   Nao se escreve no style= do elemento: o pe-product.css tem
       html body .gs-color-thumb{ background:var(--pp-sand) !important }
   e um !important numa folha GANHA a um style= sem !important. Vai
   por variavel (--pe-dot / --pe-dot-img), que o pe-fix11.css aplica.

   C) O DEFEITO DE COMPRA
   O theme.js so' escreve a variante no <select id="varSel"> quando se
   CLICA numa cor ou num tamanho, e o select nasce vazio. Numa mala,
   que so' tem cor, a primeira bola vem marcada pelo Liquid sem nada
   escrito no select: quem carregasse em COMPRAR levava com "Please
   select a size" numa mala sem tamanhos.
*/
(function () {
  var SEP = '|||';
  var SNAP = null;   /* as fotos originais, tiradas uma vez */
  var CUR = [];      /* as fotos da cor que esta' a ser mostrada */
  var IDX = 0;
  var WIRED = false;

  /* ================= cores ================= */
  var C = {
    'preto':'#111111','black':'#111111','nero':'#111111','noir':'#111111',
    'branco':'#FFFFFF','white':'#FFFFFF','bianco':'#FFFFFF','blanc':'#FFFFFF',
    'cinzento':'#9A9A9A','cinza':'#9A9A9A','grey':'#9A9A9A','gray':'#9A9A9A','grigio':'#9A9A9A','gris':'#9A9A9A',
    'antracite':'#3A3A3A',
    'bege':'#D8C7AE','beige':'#D8C7AE',
    'cru':'#E6DCC8','ecru':'#E6DCC8','creme':'#F2E9DA','cream':'#F2E9DA','marfim':'#F4EFE4','ivory':'#F4EFE4',
    'areia':'#DCCFB4','sand':'#DCCFB4',
    'castanho':'#6B4A32','brown':'#6B4A32','marrone':'#6B4A32','marron':'#6B4A32',
    'camel':'#C19A6B','taupe':'#9A8C7E','caqui':'#8A8455','khaki':'#8A8455',
    'vermelho':'#C62828','red':'#C62828','rosso':'#C62828','rouge':'#C62828',
    'bordo':'#6E1F2A','bordô':'#6E1F2A','burgundy':'#6E1F2A','bordeaux':'#6E1F2A',
    'coral':'#F0785A',
    'rosa':'#E8A0B8','pink':'#E8A0B8','rose':'#E8A0B8',
    'fucsia':'#D6247E','fúcsia':'#D6247E','fuchsia':'#D6247E',
    'roxo':'#6A3D9A','violeta':'#6A3D9A','purple':'#6A3D9A','violet':'#6A3D9A','viola':'#6A3D9A',
    'lilas':'#C3AEDC','lilás':'#C3AEDC','lilac':'#C3AEDC',
    'azul':'#2F5DA8','blue':'#2F5DA8','blu':'#2F5DA8','bleu':'#2F5DA8',
    'azul-marinho':'#17233F','navy':'#17233F',
    'azul-claro':'#7FB3E0','azul-celeste':'#7FB3E0','celeste':'#7FB3E0','azzurro':'#7FB3E0',
    'ganga':'#4A6A8A','denim':'#4A6A8A','jean':'#4A6A8A',
    'turquesa':'#3FB8AF','turquoise':'#3FB8AF',
    'verde':'#2E6B3F','green':'#2E6B3F','vert':'#2E6B3F',
    'verde-militar':'#4B5320','militar':'#4B5320','military':'#4B5320','army':'#4B5320',
    'amarelo':'#EBC531','yellow':'#EBC531','giallo':'#EBC531','jaune':'#EBC531',
    'mostarda':'#C99A2E','mustard':'#C99A2E','senape':'#C99A2E',
    'laranja':'#E2761B','orange':'#E2761B','arancione':'#E2761B',
    'prateado':'#C0C4C8','prata':'#C0C4C8','silver':'#C0C4C8','argento':'#C0C4C8','argent':'#C0C4C8',
    'dourado':'#C9A227','ouro':'#C9A227','gold':'#C9A227','oro':'#C9A227','dore':'#C9A227'
  };
  var RAINBOW = 'conic-gradient(#E05B5B,#E8C24A,#5BA85B,#4E8FD0,#9B6BC9,#E05B5B)';

  function key(s) {
    return (s || '').trim().toLowerCase().replace(/\s+/g, ' ').replace(/^cor\s+/, '');
  }
  function paint(val) {
    var k = key(val);
    if (!k) return { c: '#CFCFCF', img: null };
    if (C[k]) return { c: C[k], img: null };
    if (k.indexOf('multicor') > -1 || k.indexOf('multicolor') > -1 ||
        k.indexOf('estampado') > -1 || k.indexOf('fantasia') > -1) {
      return { c: '#CFCFCF', img: RAINBOW };
    }
    var words = k.split(/\s+e\s+|\s*\/\s*|\s+and\s+|\s+et\s+/);
    if (words.length > 1) {
      var a = C[key(words[0])], b = C[key(words[1])];
      if (a && b) return { c: a, img: 'linear-gradient(135deg,' + a + ' 0 50%,' + b + ' 50% 100%)' };
    }
    var p = k.split(/[^a-zà-ú-]+/);
    for (var i = 0; i < p.length; i++) { if (C[p[i]]) return { c: C[p[i]], img: null }; }
    return { c: '#CFCFCF', img: null };
  }

  function thumbs() {
    return Array.prototype.slice.call(document.querySelectorAll('.gs-color-thumb'));
  }
  /* v35b: SELETOR DE COR EM FOTOGRAFIA
     As bolinhas pintadas nao chegavam: o fornecedor manda varias cores
     com o mesmo nome ("Azul", "Azul 2", "Azul 3") e o corte da foto numa
     bolinha apanhava ora o logotipo ora o tecido. Agora cada cor e' uma
     miniatura com a foto inteira do artigo, e com 4 ou mais cores aparece
     "Ver todas as cores", que abre uma janela (folha a subir no telemovel,
     janela ao centro no computador) com as fotos grandes.
     As miniaturas originais continuam a ser a fonte de verdade: escolher
     uma cor na janela faz .click() na miniatura, e o resto do tema
     (galeria, preco, variante) reage como sempre. */
  var TX = {
    pt: { c: 'Cor', all: 'Ver todas as cores', t: 'Escolha a cor', n: 'cores', so: 'Esgotado', x: 'Fechar' },
    en: { c: 'Colour', all: 'View all colours', t: 'Choose a colour', n: 'colours', so: 'Sold out', x: 'Close' },
    es: { c: 'Color', all: 'Ver todos los colores', t: 'Elige el color', n: 'colores', so: 'Agotado', x: 'Cerrar' },
    fr: { c: 'Couleur', all: 'Voir toutes les couleurs', t: 'Choisissez la couleur', n: 'couleurs', so: 'Épuisé', x: 'Fermer' },
    de: { c: 'Farbe', all: 'Alle Farben ansehen', t: 'Farbe wählen', n: 'Farben', so: 'Ausverkauft', x: 'Schließen' },
    it: { c: 'Colore', all: 'Vedi tutti i colori', t: 'Scegli il colore', n: 'colori', so: 'Esaurito', x: 'Chiudi' }
  };
  function tx() { var l = (document.documentElement.getAttribute('lang') || 'pt').slice(0, 2).toLowerCase(); return TX[l] || TX.en; }
  function sized(u, w) { if (!u) return ''; return /width=\d+/.test(u) ? u.replace(/width=\d+/, 'width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function csCss() {
    if (document.getElementById('pe-cs-css')) return;
    var S = 'html body:not(#pe-ds):not(#pe-v35) ';
    var css = [
      S + '.gs-color-section.pe-cs .pe-cs-head{display:flex;align-items:baseline;gap:6px;margin:0 0 10px;min-height:24px}',
      S + '.gs-color-section.pe-cs .pe-cs-lbl{font:700 11px/1.2 "Archivo","Helvetica Neue",Arial,sans-serif;letter-spacing:.12em;text-transform:uppercase;color:#111}',
      S + '.gs-color-section.pe-cs .gs-color-name{margin:0 !important;padding:0 !important;font:500 13px/1.2 "Archivo","Helvetica Neue",Arial,sans-serif !important;letter-spacing:0 !important;text-transform:none !important;color:#3a3a3a !important}',
      S + '.gs-color-section.pe-cs .pe-cs-all{margin-left:auto;background:none;border:0;padding:6px 0;font:600 12px/1.2 "Archivo","Helvetica Neue",Arial,sans-serif;color:#111;text-decoration:underline;text-underline-offset:3px;cursor:pointer;white-space:nowrap}',
      S + '.gs-color-section.pe-cs .gs-color-thumbs{display:flex !important;flex-wrap:nowrap !important;gap:8px !important;overflow-x:auto !important;overflow-y:hidden !important;scroll-snap-type:x proximity;padding:4px 4px 6px !important;margin:0 -4px 4px !important;scrollbar-width:none;-webkit-overflow-scrolling:touch}',
      S + '.gs-color-section.pe-cs .gs-color-thumbs::-webkit-scrollbar{display:none}',
      S + '.gs-color-section.pe-cs .gs-color-thumb.pe-tile{flex:0 0 56px !important;width:56px !important;height:70px !important;min-width:0 !important;max-width:none !important;border-radius:10px !important;background:#F3F1EC !important;background-image:none !important;border:0 !important;box-shadow:none !important;padding:0 !important;margin:0 !important;overflow:hidden !important;scroll-snap-align:start;outline:1.5px solid transparent !important;outline-offset:2px !important;position:relative !important;transform:none !important;transition:outline-color .15s ease !important;cursor:pointer}',
      S + '.gs-color-section.pe-cs .gs-color-thumb.pe-tile.on{outline-color:#111 !important;box-shadow:none !important}',
      S + '.gs-color-section.pe-cs .gs-color-thumb.pe-tile:focus-visible{outline-color:#111 !important}',
      S + '.gs-color-section.pe-cs .gs-color-thumb.pe-tile img{display:block !important;width:100% !important;height:100% !important;object-fit:contain !important;object-position:center !important;mix-blend-mode:multiply;padding:5px !important;box-sizing:border-box !important;opacity:1 !important;border-radius:0 !important;margin:0 !important;max-width:none !important}',
      S + '.gs-color-section.pe-cs .gs-color-thumb.pe-tile.gs-color-thumb--soldout img{opacity:.45 !important}',
      S + '.gs-color-section.pe-cs .gs-color-thumb.pe-tile .gs-color-circle{border-radius:0 !important}',
      '@media (min-width:990px){' + S + '.gs-color-section.pe-cs .gs-color-thumbs{flex-wrap:wrap !important;overflow:visible !important}}',
      'html.pe-cs-lock,html.pe-cs-lock body{overflow:hidden !important}',
      'html body .pe-cs-ov{position:fixed;inset:0;z-index:2147483000;background:rgba(17,17,17,0);display:flex;align-items:flex-end;justify-content:center;transition:background .28s ease}',
      'html body .pe-cs-ov.in{background:rgba(17,17,17,.45)}',
      'html body .pe-cs-sheet{background:#fff;width:100%;max-height:88vh;max-height:88dvh;border-radius:18px 18px 0 0;transform:translateY(100%);transition:transform .32s cubic-bezier(.2,.8,.2,1);display:flex;flex-direction:column;padding-bottom:env(safe-area-inset-bottom);box-shadow:0 -10px 40px rgba(0,0,0,.12);color:#111}',
      'html body .pe-cs-ov.in .pe-cs-sheet{transform:none}',
      'html body .pe-cs-grab{width:38px;height:4px;border-radius:2px;background:#D9D9D9;margin:8px auto 0;flex:0 0 auto}',
      'html body .pe-cs-top{display:flex;align-items:center;gap:10px;padding:12px 16px 12px 20px;border-bottom:1px solid #EEE;flex:0 0 auto;touch-action:none}',
      'html body .pe-cs-ov .pe-cs-top h2#peCsT{font-family:var(--pe-serif,"Newsreader",Georgia,serif) !important;font-weight:400 !important;font-size:22px !important;line-height:1.15 !important;margin:0 !important;color:#111 !important;letter-spacing:0 !important;text-transform:none !important}',
      'html body .pe-cs-n{font:600 11px/1 "Archivo","Helvetica Neue",Arial,sans-serif;color:#6B6B6B;letter-spacing:.08em;text-transform:uppercase;padding-top:3px}',
      'html body .pe-cs-x{margin-left:auto;width:40px;height:40px;border-radius:50%;border:0;background:#F4F4F4;color:#111;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;flex:0 0 auto}',
      'html body .pe-cs-x svg{width:16px;height:16px;stroke:currentColor;fill:none;stroke-width:1.8}',
      'html body .pe-cs-grid{overflow:auto;padding:16px 20px 24px;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 12px;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}',
      '@media (min-width:480px){html body .pe-cs-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}',
      'html body .pe-cs-item{-webkit-appearance:none;appearance:none;border:0;background:none;padding:0;margin:0;text-align:left;cursor:pointer;display:flex;flex-direction:column;gap:8px;color:#111;font:inherit;-webkit-tap-highlight-color:transparent}',
      'html body .pe-cs-ph{display:block;aspect-ratio:4/5;border-radius:12px;background:#F3F1EC;overflow:hidden;position:relative;outline:1.5px solid transparent;outline-offset:2px;transition:outline-color .15s ease}',
      'html body .pe-cs-ph img{display:block;width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;padding:8%;box-sizing:border-box;transition:transform .35s ease}',
      'html body .pe-cs-item:hover .pe-cs-ph img{transform:scale(1.04)}',
      'html body .pe-cs-item.on .pe-cs-ph,html body .pe-cs-item:focus-visible .pe-cs-ph{outline-color:#111}',
      'html body .pe-cs-item:focus{outline:none}',
      'html body .pe-cs-ck{position:absolute;top:8px;right:8px;width:22px;height:22px;border-radius:50%;background:#111;display:none;align-items:center;justify-content:center}',
      'html body .pe-cs-ck svg{width:12px;height:12px;stroke:#fff;fill:none;stroke-width:2.2}',
      'html body .pe-cs-item.on .pe-cs-ck{display:flex}',
      'html body .pe-cs-nm{font:500 13px/1.3 "Archivo","Helvetica Neue",Arial,sans-serif;color:#111}',
      'html body .pe-cs-so{font:600 10.5px/1 "Archivo","Helvetica Neue",Arial,sans-serif;letter-spacing:.08em;text-transform:uppercase;color:#6B6B6B;margin-top:-3px}',
      'html body .pe-cs-item.sold .pe-cs-ph img{opacity:.45}',
      '@media (min-width:990px){html body .pe-cs-ov{align-items:center}html body .pe-cs-sheet{max-width:780px;border-radius:16px;max-height:82vh;transform:translateY(14px) scale(.985);opacity:0;transition:transform .25s ease,opacity .25s ease}html body .pe-cs-ov.in .pe-cs-sheet{opacity:1;transform:none}html body .pe-cs-grab{display:none}html body .pe-cs-top{padding:18px 18px 16px 24px}html body .pe-cs-grid{grid-template-columns:repeat(4,minmax(0,1fr));padding:20px 24px 28px}}',
      '@media (prefers-reduced-motion:reduce){html body .pe-cs-ov,html body .pe-cs-sheet,html body .pe-cs-ph img{transition:none !important}}'
    ].join('\n');
    var st = document.createElement('style'); st.id = 'pe-cs-css'; st.textContent = css;
    document.head.appendChild(st);
  }

  function csHead(sec, all) {
    if (!sec || sec.getAttribute('data-pe-cs') === '1') return;
    sec.setAttribute('data-pe-cs', '1');
    var t = tx();
    var head = document.createElement('div'); head.className = 'pe-cs-head';
    var lbl = document.createElement('span'); lbl.className = 'pe-cs-lbl'; lbl.textContent = t.c + ':';
    head.appendChild(lbl);
    var nm = sec.querySelector('.gs-color-name');
    if (nm) head.appendChild(nm);
    if (all.length >= 4) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pe-cs-all';
      b.setAttribute('aria-haspopup', 'dialog');
      b.textContent = t.all + ' (' + all.length + ')';
      b.addEventListener('click', function () { csOpen(b); });
      var pre = function () { thumbs().forEach(function (th) { var u = parts(th.getAttribute('data-images'))[0]; if (u) { var i = new Image(); i.decoding = 'async'; i.src = sized(u, 500); } }); };
      b.addEventListener('pointerenter', pre, { once: true });
      b.addEventListener('touchstart', pre, { once: true, passive: true });
      head.appendChild(b);
    }
    sec.insertBefore(head, sec.firstChild);
  }

  function csOpen(opener) {
    var all = thumbs(); if (!all.length) return;
    var t = tx();
    var ov = document.createElement('div'); ov.className = 'pe-cs-ov';
    var sh = document.createElement('div'); sh.className = 'pe-cs-sheet';
    sh.setAttribute('role', 'dialog'); sh.setAttribute('aria-modal', 'true'); sh.setAttribute('aria-labelledby', 'peCsT');
    sh.innerHTML = '<div class="pe-cs-grab" aria-hidden="true"></div><div class="pe-cs-top"><h2 id="peCsT"></h2><span class="pe-cs-n"></span><button type="button" class="pe-cs-x"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg></button></div><div class="pe-cs-grid"></div>';
    sh.querySelector('h2').textContent = t.t;
    sh.querySelector('.pe-cs-n').textContent = all.length + ' ' + t.n;
    var xb = sh.querySelector('.pe-cs-x'); xb.setAttribute('aria-label', t.x);
    var gridEl = sh.querySelector('.pe-cs-grid');
    var first = null;
    all.forEach(function (th) {
      var val = th.getAttribute('data-val') || '';
      var lab = th.getAttribute('data-label') || th.getAttribute('title') || val;
      var sold = th.getAttribute('data-sold-out') === 'true';
      var on = th.classList.contains('on');
      var src = parts(th.getAttribute('data-images'))[0] || '';
      var it = document.createElement('button');
      it.type = 'button'; it.className = 'pe-cs-item' + (on ? ' on' : '') + (sold ? ' sold' : '');
      it.setAttribute('aria-pressed', on ? 'true' : 'false');
      it.setAttribute('aria-label', lab + (sold ? ' — ' + t.so : ''));
      var ph = document.createElement('span'); ph.className = 'pe-cs-ph';
      if (src) { var im = document.createElement('img'); im.src = sized(src, 500); im.alt = ''; im.decoding = 'async'; ph.appendChild(im); }
      else { var p = paint(val); ph.style.background = p.img ? p.img : p.c; }
      var ck = document.createElement('span'); ck.className = 'pe-cs-ck'; ck.setAttribute('aria-hidden', 'true');
      ck.innerHTML = '<svg viewBox="0 0 12 12"><path d="M2.5 6.2l2.3 2.3 4.7-4.9"/></svg>';
      ph.appendChild(ck);
      var nm = document.createElement('span'); nm.className = 'pe-cs-nm'; nm.textContent = lab;
      it.appendChild(ph); it.appendChild(nm);
      if (sold) { var so = document.createElement('span'); so.className = 'pe-cs-so'; so.textContent = t.so; it.appendChild(so); }
      it.addEventListener('click', function () { if (!th.classList.contains('on')) th.click(); close(); });
      gridEl.appendChild(it);
      if (on) first = it;
    });
    ov.appendChild(sh);
    document.body.appendChild(ov);
    document.documentElement.classList.add('pe-cs-lock');
    void ov.offsetWidth; ov.classList.add('in');
    (first || xb).focus({ preventScroll: true });
    if (first && first.scrollIntoView) { try { first.scrollIntoView({ block: 'nearest' }); } catch (e) {} }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = sh.querySelectorAll('button'); if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
    var closed = false;
    function close() {
      if (closed) return; closed = true;
      document.removeEventListener('keydown', onKey, true);
      ov.classList.remove('in');
      sh.style.transform = '';
      document.documentElement.classList.remove('pe-cs-lock');
      setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 340);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    document.addEventListener('keydown', onKey, true);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    xb.addEventListener('click', close);

    /* arrastar para baixo fecha (telemovel) */
    var y0 = null, dy = 0, top = sh.querySelector('.pe-cs-top'), grab = sh.querySelector('.pe-cs-grab');
    function ts(e) { y0 = e.touches[0].clientY; dy = 0; sh.style.transition = 'none'; }
    function tm(e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sh.style.transform = 'translateY(' + dy + 'px)'; }
    function te() { if (y0 === null) return; sh.style.transition = ''; y0 = null; if (dy > 90) close(); else sh.style.transform = ''; }
    [top, grab].forEach(function (el) { el.addEventListener('touchstart', ts, { passive: true }); el.addEventListener('touchmove', tm, { passive: true }); el.addEventListener('touchend', te); });
  }

  function dotsPaint() {
    var all = thumbs(); if (!all.length) return;
    csCss();
    var sec = all[0].closest ? all[0].closest('.gs-color-section') : null;
    if (sec) sec.classList.add('pe-cs');
    all.forEach(function (t) {
      var val = t.getAttribute('data-val') || t.getAttribute('title') || '';
      var im = t.querySelector('img');
      ['background', 'background-color', 'background-image', 'background-size', 'background-position'].forEach(function (pp) { t.style.removeProperty(pp); });
      t.classList.remove('pe-dot');
      t.classList.add('pe-tile');
      if (im) {
        var s0 = im.getAttribute('src') || '';
        if (/width=120\b/.test(s0)) im.setAttribute('src', sized(s0, 240));
        if (im.getAttribute('loading') === 'lazy') im.setAttribute('loading', 'eager');
      } else {
        var p = paint(val);
        try {
          t.style.setProperty('background-color', p.c, 'important');
          t.style.setProperty('background-image', p.img || 'none', 'important');
        } catch (e) {}
      }
      if (!t.getAttribute('title')) t.setAttribute('title', val);
    });
    csHead(sec, all);
    /* a galeria desliza na horizontal: tem de poder receber foco pelo teclado */
    var gs = grid(); if (gs && !gs.hasAttribute('tabindex')) gs.setAttribute('tabindex', '0');
  }

  /* ================= galeria ================= */

  function grid() { return document.getElementById('galSlider'); }
  function dotsBox() { return document.getElementById('galDots'); }

  /* o nome do ficheiro, sem parametros: reconhece a mesma foto em
     enderecos de larguras diferentes */
  function fkey(u) {
    if (!u) return '';
    var s = String(u).split('?')[0];
    return s.substring(s.lastIndexOf('/') + 1).toLowerCase();
  }
  function parts(s) {
    if (!s) return [];
    return s.split(SEP).filter(function (x) { return x && x.length; });
  }

  function snapshot() {
    if (SNAP) return SNAP;
    var g = grid();
    var list = g ? Array.prototype.slice.call(g.querySelectorAll('.gs-img-item')) : [];
    SNAP = list.map(function (el) {
      var im = el.querySelector('img');
      var src = im ? im.getAttribute('src') : '';
      return {
        src: src,
        zoom: im ? (im.getAttribute('data-zoom') || src) : '',
        alt: im ? im.getAttribute('alt') : '',
        k: fkey(src),
        /* Fase 4E.3: atributos responsivos do no ORIGINAL (HTML servido), guardados
           junto da propria foto. So' sao reutilizados para esta mesma foto (ver render). */
        rs: im ? {
          src: src,
          srcset: im.getAttribute('srcset') || '',
          sizes: im.getAttribute('sizes') || '',
          width: im.getAttribute('width') || '',
          height: im.getAttribute('height') || '',
          decoding: im.getAttribute('decoding') || ''
        } : null
      };
    }).filter(function (o) { return o.src; });
    return SNAP;
  }

  /* PRINCIPAL: onde comeca esta cor ate onde comeca a seguinte */
  function byRange(thumb) {
    var all = snapshot();
    var list = thumbs();
    if (!all.length || !list.length) return [];

    var starts = list.map(function (t) {
      var k = fkey(parts(t.getAttribute('data-images'))[0]);
      if (!k) return -1;
      for (var i = 0; i < all.length; i++) { if (all[i].k === k) return i; }
      return -1;
    });

    var me = list.indexOf(thumb);
    if (me < 0 || starts[me] < 0) return [];

    var end = all.length;
    /* v34: o fim e' o inicio mais proximo de QUALQUER outra cor (antes so olhava as cores seguintes) */
    for (var j = 0; j < starts.length; j++) {
      if (j !== me && starts[j] > starts[me] && starts[j] < end) end = starts[j];
    }
    if (end <= starts[me]) return [];
    return all.slice(starts[me], end);
  }

  function byAlt(val) {
    var v = (val || '').trim().toLowerCase();
    if (!v) return [];
    return snapshot().filter(function (o) {
      return (o.alt || '').trim().toLowerCase() === v;
    });
  }

  function byAttr(thumb) {
    var im = parts(thumb.getAttribute('data-images'));
    var zo = parts(thumb.getAttribute('data-zoom'));
    return im.map(function (u, i) { return { src: u, zoom: zo[i] || u, alt: '' }; });
  }

  function photosOf(thumb) {
    var l = byRange(thumb);
    if (l.length) return l;
    l = byAlt(thumb.getAttribute('data-val') || '');
    if (l.length) return l;
    return byAttr(thumb);
  }

  /* marca a foto activa, sem reconstruir */
  function activate(i) {
    var g = grid();
    if (!g) return;
    var nodes = g.querySelectorAll('.gs-img-item');
    if (!nodes.length) return;
    if (i < 0) i = 0;
    if (i >= nodes.length) i = nodes.length - 1;
    IDX = i;
    Array.prototype.forEach.call(nodes, function (el, j) {
      if (j === i) { el.classList.add('gs-active'); } else { el.classList.remove('gs-active'); }
    });
    var d = dotsBox();
    if (d) {
      Array.prototype.forEach.call(d.querySelectorAll('.gal-dot'), function (b, j) {
        if (j === i) { b.classList.add('on'); } else { b.classList.remove('on'); }
      });
    }
    var p = document.getElementById('gsPrev');
    var n = document.getElementById('gsNext');
    if (p) p.disabled = (i <= 0);
    if (n) n.disabled = (i >= nodes.length - 1);
    if (window.innerWidth <= 1100) {
      var t = nodes[i];
      if (t) { try { g.scrollTo({ left: t.offsetLeft, behavior: 'smooth' }); } catch (e) {} }
    }
  }

  /* RECONSTROI a galeria com as fotos desta cor.
     Tem de reconstruir, e nao reaproveitar: quando isto corre, os
     outros scripts ja' deixaram um unico enquadramento no lugar. */
  function render(list, alt) {
    var g = grid();
    if (!g || !list || !list.length) return;

    CUR = list;
    g.innerHTML = '';
    g.classList.remove('gs-img-grid--single', 'gs-img-grid--three');
    if (list.length === 1) g.classList.add('gs-img-grid--single');
    else if (list.length === 3) g.classList.add('gs-img-grid--three');

    list.forEach(function (o, i) {
      var d = document.createElement('div');
      d.className = 'gs-img-item' + (i === 0 ? ' gs-active' : '');
      d.setAttribute('data-index', String(i));
      var im = document.createElement('img');
      /* Fase 4E.3: o loading tem de vir ANTES do src - uma imagem com src
         comeca logo a descarregar, e o lazy definido depois ja' nao a trava. */
      im.loading = i === 0 ? 'eager' : 'lazy';
      /* Fase 4E.3: a foto principal recupera srcset/sizes/width/height/decoding
         do no original - so' quando este objeto e' o retrato dessa mesma foto
         (veio do SNAP e o endereco e' identico). Assim o browser reaproveita o
         candidato ja' descarregado pelo HTML em vez de pedir outro de 900 px.
         Fotos sem correspondencia segura (ex. byAttr) ficam como antes. */
      var rs = (i === 0 && o.rs && o.rs.src && o.rs.src === o.src) ? o.rs : null;
      if (rs) {
        if (rs.srcset) im.setAttribute('srcset', rs.srcset);
        if (rs.sizes) im.setAttribute('sizes', rs.sizes);
        if (rs.width) im.setAttribute('width', rs.width);
        if (rs.height) im.setAttribute('height', rs.height);
        if (rs.decoding) im.setAttribute('decoding', rs.decoding);
        im.setAttribute('fetchpriority', 'high');
      }
      /* Fase 4E.4: as secundarias (i > 0) recuperam so' srcset e sizes do no
         original, com a MESMA regra de seguranca da principal (objeto do SNAP e
         endereco identico). Assim o browser escolhe o mesmo candidato que o HTML
         ja' pediu (ex. w1200) em vez de descarregar a mesma foto de novo a 900 px.
         Mantem-se loading="lazy" e NAO se poe fetchpriority. Fotos sem
         correspondencia segura ficam como antes. */
      var rs2 = (i > 0 && o.rs && o.rs.src && o.rs.src === o.src) ? o.rs : null;
      if (rs2) {
        if (rs2.srcset) im.setAttribute('srcset', rs2.srcset);
        if (rs2.sizes) im.setAttribute('sizes', rs2.sizes);
      }
      im.src = o.src;
      im.setAttribute('data-zoom', o.zoom || o.src);
      /* v30 Fase 1J: o texto alternativo diz o produto e a cor (antes so a cor, ex. "Preto") */
      var peT = g.getAttribute('data-pe-title');
      im.alt = peT ? (peT + (alt ? ' – ' + alt : '')) : (alt || o.alt || '');
      im.draggable = false;
      d.appendChild(im);
      g.appendChild(d);
    });

    var d2 = dotsBox();
    if (d2) {
      d2.innerHTML = '';
      if (list.length > 1) {
        d2.style.display = '';
        list.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'gal-dot' + (i === 0 ? ' on' : '');
          b.setAttribute('data-index', String(i));
          b.setAttribute('aria-label', (d2.getAttribute('data-t-photo') || 'Foto') + ' ' + (i + 1)); /* v30 Fase 1J: na lingua da pagina */
          d2.appendChild(b);
        });
      } else {
        d2.style.display = 'none';
      }
    }

    try { g.scrollTo({ left: 0, behavior: 'auto' }); } catch (e) { g.scrollLeft = 0; }
    activate(0);
  }

  /* clicar na foto, nos pontinhos e nas setas.
     Como passamos a substituir os nos, os ouvintes que o tema lhes
     tinha posto desaparecem - ficam aqui, delegados, uma so' vez. */
  function wire() {
    if (WIRED) return;
    WIRED = true;

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      var dot = e.target.closest('#galDots .gal-dot');
      if (dot) {
        activate(parseInt(dot.getAttribute('data-index'), 10) || 0);
        return;
      }
      var item = e.target.closest('#galSlider .gs-img-item');
      if (item) {
        var i = parseInt(item.getAttribute('data-index'), 10) || 0;
        activate(i);
        if (typeof window.openLb === 'function') {
          try { window.openLb(i); } catch (err) {}
        }
        return;
      }
      var prev = e.target.closest('#gsPrev');
      if (prev) { activate(IDX - 1); return; }
      var next = e.target.closest('#gsNext');
      if (next) { activate(IDX + 1); return; }
    }, false);
  }

  /* ================= variante ================= */

  function hasSizes() { return document.querySelectorAll('.sz-btn').length > 0; }

  function pick(val, onlyAvailable) {
    var sel = document.getElementById('varSel');
    if (!sel || !val) return null;
    var opts = sel.options;
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (!o.value) continue;
      if (o.text.split(' / ').map(function (t) { return t.trim(); }).indexOf(String(val).trim()) === -1) continue; /* v27: exato */
      if (onlyAvailable && o.disabled) return null;
      sel.value = o.value;
      var ab = document.getElementById('prodAtcBtn');
      if (ab) ab.dataset.vid = o.value;
      try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      return o;
    }
    return null;
  }

  function mark(thumb) {
    var opt = thumb.getAttribute('data-opt') || '';
    var all = document.querySelectorAll('.gs-color-thumb[data-opt="' + opt + '"]');
    Array.prototype.forEach.call(all, function (b) {
      if (b === thumb) { b.classList.add('on'); } else { b.classList.remove('on'); }
    });
    var lab = document.getElementById('optV-' + opt);
    var val = thumb.getAttribute('data-label') || thumb.getAttribute('data-val'); /* v34: nome na lingua da pagina */
    if (lab && val) lab.textContent = val;
  }

  /* ================= cliques na cor ================= */

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.gs-color-thumb') : null;
    if (!t) return;

    snapshot();
    var list = photosOf(t);

    function apply() {
      mark(t);
      if (list.length) render(list, t.getAttribute('data-label') || t.getAttribute('data-val') || '');
    }
    apply();
    /* rede de seguranca: se algo assincrono voltar a mexer na galeria,
       a ultima palavra continua a ser nossa */
    setTimeout(apply, 0);
    setTimeout(apply, 140);

    if (!hasSizes()) pick(t.getAttribute('data-val'), false);
  }, false);

  /* ================= arranque ================= */

  function init() {
    var list = thumbs();
    if (!list.length) return;

    snapshot();      /* ANTES de qualquer reconstrucao */
    dotsPaint();
    wire();

    var chosen = document.querySelector('.gs-color-thumb.on') || list[0];

    if (!hasSizes()) {
      if (!pick(chosen.getAttribute('data-val'), true)) {
        for (var i = 0; i < list.length; i++) {
          if (pick(list[i].getAttribute('data-val'), true)) { chosen = list[i]; break; }
        }
      }
      mark(chosen);
    }

    if (!grid()) return;
    var only = photosOf(chosen);
    if (only.length && only.length < snapshot().length) {
      render(only, chosen.getAttribute('data-label') || chosen.getAttribute('data-val') || '');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { dotsPaint(); });
})();
